import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { Button, Box, Text, Modal, CustomModalLayout, SectionHelper, FormField, InputArea, TextButton, Image } from '@wix/design-system';
import { Add, AddSmall, Delete } from '@wix/wix-ui-icons-common';
import cn from 'classnames';
import s from './ItemsSelectionWidget.module.scss';
export const ItemsSelectionWidgetRaw = _ref => {
  var _data$secondaryButton, _data$primaryButton;
  let {
    widgetProps,
    openModal,
    selectedItems
  } = _ref;
  const {
    data,
    context,
    config
  } = widgetProps;
  const {
    t
  } = context;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(ITEMS_SELECTION_WIDGET, onWidgetActionData, data.providerKey);
    };
    return handler;
  };
  const selectedValues = selectedItems.map(item => item.id);
  const selectedTitles = selectedItems.map(item => item.name || '');
  const hasSelectedItems = selectedValues.length > 0;
  const addLabel = data.addLabel || (t == null ? void 0 : t('CommonWidget.ItemsSelection.CTA.add'));
  const editLabel = data.editLabel || (t == null ? void 0 : t('CommonWidget.ItemsSelection.CTA.edit'));
  const openModalButtonLabel = hasSelectedItems ? editLabel : addLabel;
  const body = /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "space-between",
    verticalAlign: "middle"
  }, hasSelectedItems && /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, t == null ? void 0 : t('CommonWidget.ItemsSelection.title.selected')), /*#__PURE__*/React.createElement(WithDisabledControl, {
    t: t,
    isDisabled: areControlsDisabled,
    onEnable: enableControls,
    rootElementStyle: hasSelectedItems ? undefined : {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(s.button, {
      [s.buttonWithSelected]: hasSelectedItems,
      [s.buttonDisabled]: areControlsDisabled
    }),
    onClick: openModal
  }, /*#__PURE__*/React.createElement("div", {
    className: s.buttonLabelWrapper
  }, /*#__PURE__*/React.createElement(TextButton, {
    prefixIcon: hasSelectedItems ? undefined : /*#__PURE__*/React.createElement(AddSmall, null),
    size: "tiny"
  }, openModalButtonLabel))))), hasSelectedItems && /*#__PURE__*/React.createElement("div", {
    className: cn(s.selectedItems, {
      [s.selectedItemsWithScroll]: selectedItems.length > 4
    })
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "16px"
  }, selectedItems.map(item => {
    var _item$image, _item$image2;
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: s.item
    }, !!((_item$image = item.image) != null && _item$image.url) && /*#__PURE__*/React.createElement("div", {
      className: s.itemImage
    }, /*#__PURE__*/React.createElement(Image, {
      src: (_item$image2 = item.image) == null ? void 0 : _item$image2.url,
      width: "100%",
      height: "100%"
    })), !!item.name && /*#__PURE__*/React.createElement("div", {
      className: s.itemName
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, item.name)), !!item.note && /*#__PURE__*/React.createElement("div", {
      className: s.itemNote
    }, /*#__PURE__*/React.createElement(Text, {
      ellipsis: true,
      showTooltip: true
    }, item.note)));
  }))));
  const selectedItemsAsHiddenString = `<HIDDEN>${JSON.stringify(selectedItems)}</HIDDEN>`;
  const secondaryButton = data.secondaryButton ? {
    ...data.secondaryButton,
    disableIfNothingSelected: true,
    respondText: data.secondaryButton.respondText ? `${data.secondaryButton.respondText}${selectedItemsAsHiddenString}` : undefined
  } : undefined;
  const primaryButton = data.primaryButton ? {
    ...data.primaryButton,
    disableIfNothingSelected: true,
    respondText: data.primaryButton.respondText ? `${data.primaryButton.respondText}${selectedItemsAsHiddenString}` : undefined
  } : undefined;
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    secondaryButton: secondaryButton,
    primaryButton: primaryButton,
    context: context,
    selectedValues: selectedValues,
    selectedTitles: selectedTitles,
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', (_data$secondaryButton = data.secondaryButton) == null ? void 0 : _data$secondaryButton.label),
    onPrimaryButtonClick: handleButtonClick('primary_button_click', (_data$primaryButton = data.primaryButton) == null ? void 0 : _data$primaryButton.label),
    footerButtonsAsColumn: data.footerButtonsAsColumn,
    disabled: areControlsDisabled,
    onEnableControls: enableControls,
    hideButtonsIfNothingSelected: true
  }, body);
};
const ItemsSelectionWidgetCmp = props => {
  const [selectedItems, setSelectedItems] = useState([]);
  const maxSelected = parseInt(props.data.maxSelected, 10) || 1;
  const generateItem = name => {
    return {
      id: uuidv4(),
      name,
      image: {
        url: 'https://picsum.photos/200/300'
      },
      note: '10$'
    };
  };
  const initialItems = selectedItems.length > 0 ? selectedItems : maxSelected === 1 ? [generateItem('Item 1')] : [generateItem('Item 1'), generateItem('Item 2')];
  const [items, setItems] = useState(initialItems.map(initialItem => JSON.stringify(initialItem, null, 2)));
  const [errors, setErrors] = useState([]);
  const [isModalOpened, setModalOpened] = useState(false);
  const openModal = () => setModalOpened(true);
  const closeModal = () => setModalOpened(false);
  const addNewItem = () => {
    const newItem = generateItem(`Item ${items.length + 1}`);
    setItems(v => [...v, JSON.stringify(newItem, null, 2)]);
  };
  const onItemEdit = (index, itemJsonString) => {
    setItems(v => v.map((item, i) => i === index ? itemJsonString : item));
  };
  const onItemRemove = index => {
    setItems(items.filter((_, i) => i !== index));
  };
  const onConfirm = () => {
    setErrors([]);
    try {
      const resultItems = items.map((item, index) => {
        try {
          return JSON.parse(item);
        } catch (err) {
          const newErrors = [];
          newErrors[index] = true;
          setErrors(newErrors);
          return null;
        }
      });
      if (resultItems.some(item => item === null)) {
        return;
      }
      setSelectedItems(resultItems);
      closeModal();
    } catch (e) {
      console.error('onConfirm failed');
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ItemsSelectionWidgetRaw, {
    widgetProps: props,
    openModal: openModal,
    selectedItems: selectedItems
  }), /*#__PURE__*/React.createElement(Modal, {
    isOpen: isModalOpened,
    onRequestClose: closeModal,
    shouldCloseOnOverlayClick: true
  }, /*#__PURE__*/React.createElement(CustomModalLayout, {
    primaryButtonText: "Confirm",
    secondaryButtonText: "Cancel",
    onCloseButtonClick: closeModal,
    secondaryButtonProps: {
      onClick: closeModal
    },
    primaryButtonProps: {
      onClick: onConfirm
    },
    title: "Items Selection (Pikachu)",
    content: /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP2"
    }, /*#__PURE__*/React.createElement(Box, {
      gap: "SP1",
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(SectionHelper, {
      skin: "warning"
    }, "Items Selection is designed for use within Business Manager. But you can test it with mock Items.", ' ', /*#__PURE__*/React.createElement("a", {
      href: "https://bo.wix.com/pages/items-selection/docs/getting-started/introduction",
      target: "_blank",
      rel: "noreferrer"
    }, "Learn more"))), /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP2"
    }, items.map((item, index) => /*#__PURE__*/React.createElement(Box, {
      key: index,
      gap: "SP2",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Box, {
      flexGrow: 1,
      direction: "horizontal",
      gap: "SP1",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(FormField, {
      label: `Item #${index + 1}`,
      status: errors[index] ? 'error' : undefined,
      statusMessage: errors[index] ? 'Invalid JSON' : undefined
    }, /*#__PURE__*/React.createElement(InputArea, {
      value: item,
      onChange: e => {
        onItemEdit(index, e.target.value);
      },
      autoGrow: true
    })), /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      skin: "destructive",
      onClick: () => onItemRemove(index),
      prefixIcon: /*#__PURE__*/React.createElement(Delete, null)
    })))), items.length < maxSelected && /*#__PURE__*/React.createElement(Box, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: addNewItem,
      prefixIcon: /*#__PURE__*/React.createElement(Add, null),
      size: "tiny",
      skin: "dark"
    }, "Create new mock Item"))))
  })));
};
export const ItemsSelectionWidget = props => {
  return /*#__PURE__*/React.createElement(ItemsSelectionWidgetCmp, props);
};
export const ITEMS_SELECTION_WIDGET = 'ITEMS_SELECTION_WIDGET';
//# sourceMappingURL=ItemsSelectionWidget.js.map